document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#expenses-chart");
  if (chartEl && window.ApexCharts) {
    const params = new URLSearchParams(window.location.search);

    fetch(`/reports/expenses.json?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item => item.date);
        const seriesData = data.map(item => item.total);

        const options = {
          series: [{ name: "Expenses", data: seriesData }],
          chart: { height: 300, type: "line", toolbar: { show: false } },
          colors: ["#dc3545"],
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: { categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading expenses chart data:", error));
  }
});
